'use client';

import React from 'react';
import { faArrowUpRight } from '@fortawesome/pro-regular-svg-icons';
import { PulseButton } from 'src/components/PulseUI';

export interface CrmLink {
  crm_link?: string;
  crm_status?: string | null;
  owner?: {
    firstname?: string;
    lastname?: string;
  };
}

interface CompactCRMButtonProps {
  crmLinks: CrmLink[];
}

const CompactCRMButton: React.FC<CompactCRMButtonProps> = ({ crmLinks }) => {
  if (crmLinks.length === 0) return null;

  const firstLink = crmLinks[0];
  const count = crmLinks.length;
  const label = firstLink?.crm_status
    ? firstLink.crm_status
    : count === 1
    ? `${firstLink?.owner?.firstname || ''} ${firstLink?.owner?.lastname || ''}`.trim() ||
      'View in CRM'
    : `${count} Records`;

  const href = firstLink?.crm_link;

  return (
    <PulseButton
      size="xs"
      variant="solid"
      className="bg-green-100 hover:bg-green-50 text-green-600 whitespace-nowrap"
      endDecorator={faArrowUpRight}
      aria-label={`Open CRM record: ${label}`}
      data-testid="compact-crm-button"
      onClick={() => {
        if (href) window.open(href, '_blank', 'noopener,noreferrer');
      }}
    >
      {label}
    </PulseButton>
  );
};

export default CompactCRMButton;
